export default "__VITE_ASSET__jHKhiCbp__"